require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-ceo-ning-duong-selected-for-national-credit-union-advisory.json") })
        }
      }, "path---es-articles-financial-center-ceo-ning-duong-selected-for-national-credit-union-advisory");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-ceo-ning-duong-selected-for-national-credit-union-advisory!./.cache/json/es-articles-financial-center-ceo-ning-duong-selected-for-national-credit-union-advisory.json
// module id = 2109
// module chunks = 231608221292675